import { traceReducer } from "../reducer/TraceReducer";

export const reducer = traceReducer;